// tslint:disable:no-invalid-template-strings

export const BASE_SEARCH_GA = (client: string) => ({
  event: 'AutoEvent',
  eventCategory: `${client} - Otsing`,
  eventAction: 'Site Search',
});
